
define('text!templates/modules/calendar/activity/detail/blocks/advanced-details.html',[],function () { return '<div class="activity-list"></div>\n<div class="time-input"></div>\n<div class="difficulty"></div>\n';});

